

































































import { defineComponent, ref, computed } from '@vue/composition-api';
import AtoneAlert from '@berlin-front/common/components/atone-components/AtoneAlert';
import AppButton from '@berlin-front/common/components/elements/AppButton';
import AppCard from '@berlin-front/common/components/elements/AppCard';
import AppContainer from '@berlin-front/common/components/elements/AppContainer';
import AppMessageList from '@berlin-front/common/components/elements/AppMessageList';
import AppRow from '@berlin-front/common/components/elements/AppRow';
import AppText from '@berlin-front/common/components/elements/AppText';
import AppSupplement from '@berlin-front/common/components/elements/AppSupplement';
import ModalHeader from '@berlin-front/common/components/clusters/ModalHeader';
import UserNameFooter from '@clusters/UserNameFooter';

import { useContext } from '@berlin-front/common/composables/context';

import { ModalHeaderContext } from '@services/ModalHeaderContext';
import { HEADER_TYPE } from '@berlin-front/common/components/clusters/ModalHeader/composable';
import { TEXT_COLOR, TEXT_SIZE, TEXT_WEIGHT } from '@berlin-front/common/components/elements/AppText/composable';
import { formatTelNumber, windowOpenNewTab, bemx, isPhone } from '@berlin-front/common/utils';

import exclamationCircleIcon from '@berlin-front/common/assets/exclamation-circle-icon.svg';

import { CallAuthContext } from './composable';

export default defineComponent({
  name: 'CallAuthView',
  components: {
    AtoneAlert,
    AppButton,
    AppCard,
    AppContainer,
    AppMessageList,
    AppRow,
    AppSupplement,
    AppText,
    ModalHeader,
    HeaderContextConsumer: ModalHeaderContext.consumer,
    UserNameFooter,
  },

  setup() {
    const { useAuthCall } = useContext(CallAuthContext);
    const authCallState = useAuthCall();
    const ATONE_FAQ_URL = process.env.VUE_APP_ATONE_FAQ_URL;

    // TODO: アラートメッセージ、この画面ではネットワークエラーくらい
    const alertMessages = ref<string[]>([]);

    const callButtonClasses = computed(() =>
      bemx('CallAuthView__CallButton', {
        isPhone: isPhone(),
      }),
    );

    return {
      // 状態
      authCallState,

      // 表示項目
      alertMessages,
      imgSrc: exclamationCircleIcon,
      callButtonClasses,

      // 関数
      formatTelNumber,
      windowOpenNewTab,

      // 定数
      HEADER_TYPE,
      TEXT_COLOR,
      TEXT_SIZE,
      TEXT_WEIGHT,
      ATONE_FAQ_URL,
    };
  },
});
